import { SurveyRepository } from "../../../repositories/surveyRepository"
import { UseCase } from "../../useCase"
import { DeleteSurveyRequest } from "./request"

export class DeleteSurveyUseCase implements UseCase<DeleteSurveyRequest, void> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(microsite_id: DeleteSurveyRequest) {
		return this._repository.deleteSurvey(microsite_id)
	}
}
